// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1u7Vj","fileBtn":"File_fileBtn__1Qy3z","closeBtn":"File_closeBtn__2Lc62","fileSelected":"File_fileSelected__3oCz0","disabled":"File_disabled__3vCQN"};